export default __webpack_public_path__ + "static/darkTestimonialsBg-76a27d8957f9d7a81d70d32a956f3d5b.png";